import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useRouter } from 'next/router'
import useTranslation from 'next-translate/useTranslation'

import { Button } from '@/components/Button'
import { Slider } from './ProductViewSlider'
import Icons from '@/components/Icons'
import { Text } from '@/components/Text'
import {
  Wrapper,
  UpperPart,
  ProductImagesWrapper,
  NextImages,
  NextImagesWrapper,
  MainImage,
  DescriptionWrapper,
  LowerPart,
  NextImageWrapper,
  ButtonWrapper,
  ProductMainDescription,
  SliderWrapper,
  SliderBackground,
  Close,
  VisibleImages,
  BrandWrapper,
  ProductDescription,
  SizeWrapper,
  Item,
  RadioButtonLabel,
  RadioButton,
  NameWrapper,
  VariantWrapper,
  NotSelectable,
} from './ProductViewStyles'
import { ProductPrice } from './ProductPrice'
import { BackGround } from '@/components/Background'

import { addToCartAction } from '@/redux/actions'

import ProductInfo from './ProductInfo'
import ProductTags from '../ProductCard/ProductTags'

import { isNewerThan } from '@/utils/Helpers/Validate'
import { ColorsMap } from '@/utils/Theme'

import { ProductInterface, ProductVariantInterface } from '@/types/Product'

export interface ProductViewProps {
  product?: ProductInterface
  currency: string
  clickedImage?: number
  showMoreImages?: boolean
  open?: boolean
}

export const ProductView: React.FC<ProductViewProps> = ({ product, currency }) => {
  const dispatch = useDispatch()
  const { t } = useTranslation('common')
  const router = useRouter()

  const [position, setPosition] = useState<number>(0)
  const [showMore, setShowMore] = useState<boolean>(false)
  const [isSliderOpen, setIsSliderOpen] = useState<boolean>(false)
  const [variantData, setVariantData] = useState([])
  const [variant, setVariant] = useState<ProductVariantInterface>(product.variants[0])

  let mainImage

  if (product.images.length > 0) {
    mainImage = product.images[0]
  }

  const printImages = () => {
    return (
      <NextImagesWrapper hasSecondaryPhotos={product.images.length > 1}>
        <NextImages showMoreImages>
          {product.images
            .filter((_, i) => {
              return i <= 4 && i > 0
            })
            .map((image, i) => {
              return (
                <NextImageWrapper
                  onClick={() => {
                    setPosition(i + 1)
                    setIsSliderOpen(true)
                  }}
                  key={i + 1}
                >
                  <img src={image.url} alt={image.alt} />
                </NextImageWrapper>
              )
            })}
        </NextImages>
      </NextImagesWrapper>
    )
  }

  if (variantData.length <= 0) {
    let defaultVariant = []

    product.variants[0].properties.forEach((property) => {
      if (property.id === product.properties[0].id) {
        defaultVariant.push([property.name, property.value.name])
      }
    })

    setVariantData(Object.fromEntries(defaultVariant))
  }

  useEffect(() => {
    if (variantData) {
      setVariantData([])
    }
  }, [router.asPath])

  useEffect(() => {
    let variantId = null
    let match = []
    product.variants.forEach((variant) => {
      let variantFail = []
      variant.properties.map((property) => {
        let fail = true
        for (const [, value] of Object.entries(variantData)) {
          if (value == property.value.name) {
            fail = false
          }
        }
        if (!fail) {
          match.push(variant.id)
        }
        variantFail.push(fail)
      })

      match.forEach((matched) => {
        product.variants.map((variant) => {
          if (matched == variant.id) {
            variant.properties.map((property) => {
              document.getElementById(property.value.id).style.opacity = '1'
              document.getElementById(property.value.id).style.pointerEvents = 'initial'
              document.getElementById('select' + property.value.id).style.display = 'none'
            })
          } else {
            variant.properties.map((property) => {
              if (property.name != product.variants[0].properties[0].name) {
                document.getElementById(property.value.id).style.opacity = '0.5'
                document.getElementById('select' + property.value.id).style.display = 'initial'
                document.getElementById(property.value.id).style.pointerEvents = 'none'
              }
            })
          }
        })
      })
      if (!variantFail.find((fail) => fail === true)) {
        variantId = variant.id
      }
    })

    if (variantId != null) {
      setVariant(product.variants.find((variant) => variant.id == variantId))
    } else {
      setVariant(null)
    }
  }, [variantData])

  const variants = () => {
    const handleSelectChange = (event, property) => {
      const { value, name } = event.target

      if (name === 'main') {
        setVariantData({ [property]: value })
      } else {
        setVariantData((prevState) => ({ ...prevState, [property]: value }))
      }
    }

    return (
      <SizeWrapper>
        {product.properties.map((mainProperty) => {
          return (
            <VariantWrapper>
              {product.variants.map((variant) => {
                return variant.properties.map((property) => {
                  if (property.id === mainProperty.id) {
                    let isChecked = false
                    for (const [key, value] of Object.entries(variantData)) {
                      if (value === property.value.name) {
                        isChecked = true
                      }
                    }
                    return (
                      <Item id={property.value.id.toString()}>
                        <NotSelectable id={'select' + property.value.id} />
                        <RadioButton
                          type="radio"
                          name={
                            property.name == product.variants[0].properties[0].name
                              ? 'main'
                              : mainProperty.id.toString()
                          }
                          checked={isChecked}
                          id={property.value.name}
                          value={property.value.name}
                          onChange={(e) => handleSelectChange(e, property.name)}
                        />
                        <RadioButtonLabel htmlFor={property.value.name} />
                        <NameWrapper>{property.value.name}</NameWrapper>
                      </Item>
                    )
                  }
                })
              })}
            </VariantWrapper>
          )
        })}
      </SizeWrapper>
    )
  }

  return (
    <>
      <Wrapper>
        <UpperPart>
          <ProductImagesWrapper>
            <VisibleImages>
              {printImages()}
              {mainImage && (
                <MainImage
                  onClick={() => {
                    setPosition(0)
                    setIsSliderOpen(true)
                  }}
                >
                  <ProductTags
                    sale={variant.sale_price ? true : false}
                    recent={isNewerThan(new Date(product.created_at), 20)}
                  />
                  <img src={mainImage.url} alt="" />
                </MainImage>
              )}
            </VisibleImages>
            <NextImages showMoreImages={showMore}>
              {product.images.map((image, i) => {
                if (i > 4) {
                  return (
                    <NextImageWrapper
                      onClick={() => {
                        setPosition(i)
                        setIsSliderOpen(true)
                      }}
                      key={i}
                    >
                      <Button>
                        <img src={image.url} alt={image.alt} />
                      </Button>
                    </NextImageWrapper>
                  )
                }
                return null
              })}
            </NextImages>
            <Button
              variant="default"
              onClick={() => {
                setShowMore(!showMore)
              }}
              mt="1rem"
            >
              <Text fontSize="s">{product.images.length > 5 ? (showMore ? t('show-less') : t('show-more')) : ''}</Text>
            </Button>
          </ProductImagesWrapper>
          <DescriptionWrapper>
            <ProductMainDescription>
              <BrandWrapper>
                <img src={product.brand.logo} alt="" title={product.brand.name} />
              </BrandWrapper>
              <Text as="h1" textColor="primary" fontSize="l" fontWeight="bold" mb="2rem">
                {product.name}
              </Text>
              {product.type === 'variable' && variants()}
              <ProductInfo
                inStock={product.type === 'simple' ? product.variants[0].in_stock : variant.in_stock}
                perOrder={product.type === 'simple' ? product.variants[0].meta?.per_order : variant.meta?.per_order}
                perOrderWaitTime={15}
              />
              <Text textColor="primary" fontWeight="bold" fontSize="xl" mb="1rem">
                {product.type === 'simple' ? (
                  <ProductPrice
                    price={product.variants[0].price}
                    salePrice={product.variants[0].sale_price}
                    currency={currency}
                  />
                ) : (
                  <ProductPrice price={variant.price} salePrice={variant.sale_price} currency={currency} />
                )}
              </Text>
            </ProductMainDescription>
            {product.type === 'simple' ? (
              <ButtonWrapper>
                <Button
                  disabled={!product.variants[0].in_stock && !product.variants[0].meta?.per_order}
                  onClick={() => {
                    dispatch(
                      addToCartAction({
                        payload: {
                          product_id: product.id,
                          variant_id: product.variants[0].id,
                          quantity: 1,
                        },
                      })
                    )
                  }}
                  variant="horizontalRad"
                  colorVariant="primary"
                >
                  {t('add-to-cart')}
                </Button>
                <Button
                  disabled={!product.variants[0].in_stock && !product.variants[0].meta?.per_order}
                  onClick={() => {
                    dispatch(
                      addToCartAction({
                        payload: {
                          product_id: product.id,
                          variant_id: product.variants[0].id,
                          quantity: 1,
                        },
                      })
                    )
                  }}
                  variant="horizontalRad"
                  colorVariant="primaryWhite"
                >
                  {t('buy-now')}
                </Button>
              </ButtonWrapper>
            ) : (
              <ButtonWrapper>
                <Button
                  disabled={!variant.in_stock && !variant.meta?.per_order}
                  onClick={() => {
                    if (!variant) {
                      alert('Vyberte variant')
                    } else {
                      dispatch(
                        addToCartAction({
                          payload: {
                            product_id: product.id,
                            variant_id: variant.id,
                            quantity: 1,
                          },
                        })
                      )
                    }
                  }}
                  variant="horizontalRad"
                  colorVariant="primary"
                >
                  {t('add-to-cart')}
                </Button>
                <Button
                  disabled={!variant.in_stock && !variant.meta?.per_order}
                  onClick={() => {
                    if (!variant) {
                      alert('Vyberte variant')
                    } else {
                      dispatch(
                        addToCartAction({
                          payload: {
                            product_id: product.id,
                            variant_id: variant.id,
                            quantity: 1,
                          },
                        })
                      )
                    }
                  }}
                  variant="horizontalRad"
                  colorVariant="primaryWhite"
                >
                  {t('buy-now')}
                </Button>
              </ButtonWrapper>
            )}
          </DescriptionWrapper>
        </UpperPart>
        <LowerPart>
          <Text mb="1rem" textColor="primary" fontWeight="bold" fontSize="xl">
            {t('description')}
          </Text>
          <ProductDescription dangerouslySetInnerHTML={{ __html: product.description }} />
        </LowerPart>
        <SliderWrapper open={isSliderOpen}>
          <Slider variant="instant" sliderContent={product.images} clickedImageIndex={position + 1} />
          <Close
            onClick={() => {
              setIsSliderOpen(false)
            }}
          >
            <Icons.CloseOutline size="xxl" color={ColorsMap.primary} />
          </Close>
        </SliderWrapper>
      </Wrapper>
      <BackGround
        onClick={() => {
          setIsSliderOpen(false)
        }}
        clicked={isSliderOpen}
      />
    </>
  )
}
